import { MapType } from '@angular/compiler';
import { RegisterItem } from '../decorators/snitem-factory-decorator';
import { CNTreatment, CNTreatmentType } from './cntreatment';

@RegisterItem()
export class CNTreatmentKine extends CNTreatment {
    constructor(itemid: number = 0) {
        super(itemid);
        this.key = 'SNItem.CNItem.CNTreatment.CNTreatmentKine';
    }

    get type(): CNTreatmentType {
        return CNTreatmentType.Kine;
    }

    get sessionCount(): number {
        return parseInt(this.getProperty('sessionCount'), 10);
    }

    set sessionCount(count: number) {
        this.setProperty('sessionCount', count.toString());
    }

    set sessions(sessions: Map<string, boolean>) {
        this.setProperty('sessions', JSON.stringify(Object.fromEntries(sessions)));
    }

    get sessions(): Map<string, boolean> {
        if (this.getProperty('sessions') === null) {
            // build sessions
            const sessions = new Map();
            for (let i = 1 ; i <= this.sessionCount ; i++) {
                sessions.set(i.toString(), false);
            }
            // Convert to json
            this.setProperty('sessions', JSON.stringify(Object.fromEntries(sessions)));
        }
        return new Map(Object.entries(JSON.parse(this.getProperty('sessions'))));
    }

    public clone(): any {
        return new CNTreatmentKine();
    }
}
